import React, { useState, useEffect } from "react";
import { Editor } from "primereact/editor";
import { useParams, useLocation } from "react-router-dom";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu, Button, Modal,message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../UserContext";
import LoaderTeacher from "../../Loader/Loader_Teacher";
import QuizEditor from "../QuizEditor";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const { Header, Sider, Content } = Layout;

const CourseContent = () => {
	const [messageApi, contextHolder] = message.useMessage();
	const navigate = useNavigate();
	const { courseId } = useParams();
	const location = useLocation();
	const [text, setText] = useState("");
	const [currentModule, setCurrentModule] = useState(1);
	const [currentSubmodule, setCurrentSubmodule] = useState(1);
	const [activeMenuKeys, setActiveMenuKeys] = useState([]);
	const [isCourseCompleted, setIsCourseCompleted] = useState(false);
	const [courseData,setCourseData] = useState({});
	const [loading, setLoading] = useState(true);
	const { instructorapiuri, token } = useContext(UserContext);
	const [quizData,setQuizData] = useState({});
	const [emhcontent,setEMHContent] = useState({});
	const [modelVisible,setModalVisible] = useState(false);
	const [easycontent,setEasyContent] = useState({});
	const [mediumcontent,setMediumContent] = useState({});
	const [hardcontent,setHardContent] = useState({});
	const [subcontentedit, setsubcontentedit] = useState(false);


	const fetchCourseData = async () => {
		setLoading(true);
		try {
			const response = await fetch(`${instructorapiuri}/inst/${courseId}`, {
				method: "GET",
				mode: "cors",
				headers: {
					Authorization: "Bearer " + token,
				},
			});
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			const data = await response.json();
			setCourseData(data);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching course data:", error);
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchCourseData();
	}, []);
	
	const fetchModuleSubmodule = () => {
		const parts = location.pathname.split("/");
		const moduleIndex = parseInt(parts[parts.indexOf("module") + 1]);
		const submoduleIndex = parseInt(parts[parts.indexOf("submodule") + 1]);
		setCurrentModule(moduleIndex);
		setCurrentSubmodule(submoduleIndex);
	};

	

	const updateSubContent = async (module,submodule,newcontent) => {
		try {
			const response = await fetch(
				`${instructorapiuri}/inst/${courseId}/${courseData?.courseStructure[parseInt(module - 1)]?._id}/${
						courseData?.courseStructure[parseInt(module - 1)]?.subModules[
							parseInt(submodule) - 1
						]._id
					}`,
				{
					method: "PUT",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: "BEARER " + token,
					},
					body: JSON.stringify({ content: newcontent }),
				}
			);


			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();
			console.log("Received data:", data);
			await fetchCourseData();
			await fetchData();
			setLoading(false);
		} catch (error) {
			console.error("Error fetching course data:", error);
			setLoading(false);
		}
		
	} 

	const GenerateContent = async (module) => {
		setLoading(true);
		console.log(courseData.courseStructure)
		const response = await fetch(
			`${instructorapiuri}/inst/${courseId}/${courseData?.courseStructure[parseInt(currentModule + 1)]?._id}`,
			{
				method:"GET",
				headers:{
					"Authorization": "BEARER "+ token
				}
			}
		);
		const moduleData = await response.json();
		console.log(moduleData);
		await fetchCourseData();
		await fetchData();
		setLoading(false);
	};

	

	const GenerateSubContent = async (module,submodule) => {
		setLoading(true);
		const response = await fetch(`${instructorapiuri}/inst/${courseId}/${courseData.courseStructure[parseInt(module - 1)]._id}/${courseData.courseStructure[parseInt(module - 1)].subModules[parseInt(submodule) - 1]._id}`,
			{
				method:"GET",
				headers:{
					"content-type":"application/json",
					"Authorization":"BEARER " + token
				}
			}
		)
		const data = await response.json();
		console.log(data)
		setText(data?.data?.submodule_content);
		setLoading(false);
	}

	useEffect(() => {
		fetchModuleSubmodule();
	}, [location.pathname]);


	useEffect(() => {
		console.log(courseData)
		fetchData(currentModule);
		updateActiveMenuKeys();
	}, [currentModule, currentSubmodule, courseData]);
	
	const fetchData = async (module) => {

		if (!currentSubmodule && courseData && courseData.courseStructure) {
			const newquizData =
				courseData?.courseStructure[parseInt(module - 1)]?.quizId;
			setQuizData(newquizData);
		} else {
			if (courseData && courseData.courseStructure) {
				const value =
					courseData?.courseStructure[parseInt(module - 1)]?.subModules[
						parseInt(currentSubmodule - 1)
					]?.content;
				setText(value);
			}
		}
};

	const updateActiveMenuKeys = () => {
		const parts = location.pathname.split("/");
		const moduleIndex = parseInt(parts[parts.indexOf("module") + 1]);
		const submoduleIndex = parseInt(parts[parts.indexOf("submodule") + 1]);
		setActiveMenuKeys([`sub${moduleIndex}-${submoduleIndex}`]);
	};

	const handleSaveAndNext = async () => {
		const currentModuleData = courseData.courseStructure[currentModule-1];
		if (currentModuleData) {
			if (currentSubmodule < currentModuleData.subModules.length) {
				setNextSubmodule();
			} else if (currentModule < courseData.courseStructure.length) {
				setNextModule();
			} else {
				setIsCourseCompleted(true);
				
				await publish();	
			}
		}
	};

	const publish = async () => {
		setLoading(true);
		try {
			const response = await fetch(
				`${instructorapiuri}/inst/publish/${courseId}`,
				{
					method: "POST",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: "BEARER " + token,
					},
					body: "",
				}
			);

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();
			console.log("Course Publishes", data);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching course data:", error);
			setLoading(false);
		}
	}; 


	const setNextSubmodule = async () => {
		const nextSubmodule = currentSubmodule + 1;
		await updateSubContent(currentModule,currentSubmodule,text);
		setCurrentSubmodule(nextSubmodule);
		updateUrl(currentModule, nextSubmodule);
	};

	const setNextModule = async () => {
		const nextModule = currentModule + 1;
		setLoading(true);
		await GenerateContent(courseData.courseStructure[currentModule]._id);
		await fetchCourseData();
		setLoading(false);
		setCurrentModule(nextModule);
		setCurrentSubmodule(0);
		updateUrl(nextModule, 1);
	};

	const updateUrl = (module, submodule) => {
		const nextUrl = `/teacher/courses/content/${courseId}/module/${module}/submodule/${submodule}`;
		navigate(nextUrl);
	};

	const GenerateEMHContent = async (module,submodule) =>{
		setLoading(true);
		const response = await fetch(`${instructorapiuri}/inst/${courseId}/${courseData.courseStructure[parseInt(module - 1)]._id}/${courseData.courseStructure[parseInt(module - 1)].subModules[parseInt(submodule) - 1]._id}/emh`,
			{
				method:"GET",
				headers:{
					"Authorization":"BEARER " + token
				}
			}
		)
		const data = await response.json()
		console.log(data);
		setLoading(false);
		setEMHContent(data);
		setModalVisible(true);
	}

	const saveEMH = async (
		level,
		updatedContent
	) => {
		const finaldata = { content : updatedContent };
		const response = await fetch(`${instructorapiuri}/inst/${courseId}/${courseData?.courseStructure[parseInt(currentModule - 1)]?._id}/${courseData?.courseStructure[parseInt(currentModule - 1)]?.subModules[parseInt(currentSubmodule) - 1]?._id}/${level}`,
			{
				method:"PUT",
				headers:{
					"content-type":"application/json",
					"Authorization":"BEARER " + token
				},
				body : JSON.stringify(finaldata)
			}
		)
		const data = await response.json();
		setLoading(false);
		messageApi.open({
			type: "success",
			content:`${level} content Saved Successfully...!`,
		});
	}
	

	if (loading) {
		return <div style={{position:"absolute",top:"50%",transform:"tranlateY(-50%)"}}><LoaderTeacher loader_text={"Generating content"} /></div>;
	}
	
	return (
		<Layout style={{ minHeight: "100vh" }}>
			<Sider
				breakpoint="md"
				collapsedWidth="0"
				className="course-side-menu"
				style={{
					position: "fixed",
				}}>
				<Menu
					mode="inline"
					theme="dark"
					selectedKeys={activeMenuKeys}
					openKeys={
						courseData &&
						courseData.courseStructure &&
						courseData.courseStructure.map((module, index) => `sub${index + 1}`)
					}
					className="menu">
					{courseData &&
						courseData.courseStructure &&
						courseData.courseStructure.map((module, index) => (
							<Menu.SubMenu key={`sub${index + 1}`} title={module.moduleName}>
								{module &&
									module.subModules.map((submodule, subIndex) => (
										<Menu.Item key={`sub${index + 1}-${subIndex + 1}`}>
											<Link
												to={`/teacher/courses/content/${courseId}/module/${
													index + 1
												}/submodule/${subIndex + 1}`}>
												{submodule.name}
											</Link>
										</Menu.Item>
									))}
								<Menu.Item key={`quiz${index + 1}-quiz`}>
									<Link
										to={`/teacher/courses/content/${courseId}/module/${
											index + 1
										}/quiz`}>
										{module.quizId.name}
									</Link>
								</Menu.Item>
							</Menu.SubMenu>
						))}
					<Menu.Item key={`save`}>
						<Link
							to={`/teacher/courses/${courseId}/save`}>
							Save Course
						</Link>
					</Menu.Item>
				</Menu>
			</Sider>
			<Layout>
				<Header className="head">
					<div className="title">LEARN YOUR WAY</div>
					<div
						style={{ display: "flex", alignItems: "center" }}
						className="head-icons">
						<Link to={"/"}>
							<UserOutlined />
						</Link>
						<Link to={"/"}>
							<LogoutOutlined />
						</Link>
					</div>
				</Header>
				<Content className="content">
					<div className="course-editor">
						{!currentSubmodule && courseData ? (
							<>
								<QuizEditor
									quizData={quizData}
									courseId={courseId}
									moduleId={courseData?.courseStructure[currentModule - 1]?._id}
								/>
							</>
						) : (
							<>
								{!subcontentedit ? (
									<>
										<Markdown rehypePlugins={[rehypeRaw]}>{text}</Markdown>
										<Button onClick={() => setsubcontentedit(true)}>
											Edit
										</Button>
										<Button
											onClick={() =>
												GenerateSubContent(currentModule, currentSubmodule)
											}>
											Generate Using AI
										</Button>
										<Button
											onClick={() =>
												GenerateEMHContent(currentModule, currentSubmodule)
											}>
											Generate For All Levels
										</Button>
										<Button type="primary" onClick={handleSaveAndNext}>
											{isCourseCompleted ? "Save Course" : "Save and Next"}
										</Button>
									</>
								) : (
									<>
										<Editor
											value={text}
											onTextChange={(e) => setText(e.htmlValue)}
											style={{ height: "320px" }}
										/>
										<Button onClick={() => setsubcontentedit(false)}>
											Save
										</Button>
									</>
								)}

								<Modal
									open={modelVisible}
									okText=""
									// onOk={async () => await handleKnowledgeTest(course)}
									onCancel={() => setModalVisible(false)}
									footer=""
									cancelText="">
									<Editor
										value={emhcontent.easy}
										onTextChange={(e) => setEasyContent(e.htmlValue)}
										style={{ height: "320px" }}
									/>
									<Button onClick={() => saveEMH("easy", easycontent)}>
										Save
									</Button>
									<Editor
										value={emhcontent.medium}
										onTextChange={(e) => setMediumContent(e.htmlValue)}
										style={{ height: "320px" }}
									/>
									<Button onClick={() => saveEMH("medium", mediumcontent)}>
										Save
									</Button>
									<Editor
										value={emhcontent.hard}
										onTextChange={(e) => setHardContent(e.htmlValue)}
										style={{ height: "320px" }}
									/>
									<Button onClick={() => saveEMH("hard", hardcontent)}>
										Save
									</Button>
								</Modal>
							</>
						)}
					</div>
					{contextHolder}
				</Content>
			</Layout>
		</Layout>
	);
};

export default CourseContent;